import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import {
  Customers,
  Customer,
  CreateCustomer,
  UpdateCustomer,
  ImportCustomers,
  Prospects,
} from "./pages";

export const CustomersRouter = [
  <Route
    path="/prospects"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Prospects />
      </ProtectedRoute>
    }
  />,

  <Route
    path="/customers"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Customers />
      </ProtectedRoute>
    }
  />,

  <Route
    path="/customers/import"
    element={
      <ProtectedRoute roles={["Any"]}>
        <ImportCustomers />
      </ProtectedRoute>
    }
  />,

  <Route path="/customer">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateCustomer />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id"
      element={
        <ProtectedRoute roles={["Any"]}>
          <Customer />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateCustomer />
        </ProtectedRoute>
      }
    />
  </Route>,
];
